<template>
  <div id="display-tooltip"></div>

  <div class="side_buttons">
    <div v-show="this.displayLegend" class="side_legend hideOnMobile">
      <span
        @click="
          {
            this.displayLegend = !this.displayLegend;
          }
        "
        @mouseover="displayTooltip($event)"
        @mouseleave="hideTooltip"
        target="_blank"
        style="position: absolute; top: 5px; right: 5px; border-radius: 0.5rem"
        class="hideOnMobile"
        ><i data-tip="Gizle" class="las la-times-circle"></i>
      </span>

      <p>Derinlik (km)</p>
      <div class="depth_info">
        <div class="chip">
          <div class="chip-head" style="background-color: #8b0000"></div>
          <div class="chip-content">0 - 5</div>
        </div>
        <div class="chip">
          <div class="chip-head" style="background-color: #ff0000"></div>
          <div class="chip-content">5 - 10</div>
        </div>
        <div class="chip">
          <div class="chip-head" style="background-color: #ff7f01"></div>
          <div class="chip-content">10 - 20</div>
        </div>
        <div class="chip">
          <div class="chip-head" style="background-color: #fbe955"></div>
          <div class="chip-content">20 - 40</div>
        </div>
        <div class="chip">
          <div class="chip-head" style="background-color: #74fb55"></div>
          <div class="chip-content">40 - 80</div>
        </div>
        <div class="chip">
          <div class="chip-head" style="background-color: #33dae9"></div>
          <div class="chip-content">80 - 150</div>
        </div>
      </div>
      <hr style="margin: 10px; opacity: 0.3" />
      <p>Büyüklük (Mw)</p>
      <div class="magnitude_info">
        <div
          class="chip-head"
          style="height: 0.3rem; width: 0.3rem; background-color: #000"
        ></div>
        <div
          class="chip-head"
          style="height: 0.5rem; width: 0.5rem; background-color: #000"
        ></div>
        <div
          class="chip-head"
          style="height: 0.7rem; width: 0.7rem; background-color: #000"
        ></div>
        <div
          class="chip-head"
          style="height: 0.9rem; width: 0.9rem; background-color: #000"
        ></div>
      </div>
    </div>

    <span
      v-show="!this.displayLegend"
      @click="
        {
          this.displayLegend = !this.displayLegend;
        }
      "
      @mouseover="displayTooltip($event)"
      @mouseleave="hideTooltip"
      target="_blank"
      class="side_legend hideOnMobile"
      ><i data-tip="Detaylar" class="las la-info-circle"></i>
    </span>

    <span
      :onclick="darkModeSwitch"
      @mouseover="displayTooltip($event)"
      @mouseleave="hideTooltip"
      target="_blank"
      class="darklight_mode noselect"
      ><i data-tip="Gündüz/Gece Modu" class="las la-moon"></i>
    </span>
  </div>

  <div v-if="graphView" id="graphContainer">
    <div
      id="graphCloseButton"
      class="noselect"
      style="z-index: 2"
      @click="graphView = !graphView"
    >
      X
    </div>
    <GraphComponent
      style="height: 600px; width: 70vw"
      :info="{}"
      :content="graphContent"
    />
  </div>

  <section
    id="portalPage"
    :class="{ invisible: !canDisplayPortal }"
    class="fade"
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
    "
  >
    <PortalMenu />
  </section>
  <section v-bind="$attrs" id="mainPage">
    <aside v-if="canDisplayList" class="glass" id="sidebar">
      <div class="sidebar_content">
        <QuakesList
          ref="listOfQuakes"
          :quakes="quakeData"
          :values="{
            recent: quakeListRecent,
            locations: filterLocations,
            minimumMl: settings.quakeMl,
            daysBefore: settings.quakeDays,
          }"
          @emitFly="emitFly"
          @emitFilterMap="emitFilterMap"
          @emitGraph="generateGraph"
          :selectedDate="selectedDate"
          :instance="quakeListInstance"
          :graphBoundaries="graphBoundaries"
        />
      </div>
    </aside>

    <aside
      id="topbar"
      @mouseover="displayTooltip($event)"
      @mouseleave="hideTooltip"
      class="flex-column"
    >
      <div class="flex-between">
        <div style="height: fit-content" class="flex align-center">
          <button
            id="showPortalButton"
            data-tip="Deprem Bilgileri"
            @click="editorMenu('portal')"
          >
            <i class="las la-book"></i>
          </button>
          <button
            data-tip="Yakınlaş"
            class="hideOnMobile"
            @click="editorMenu('zoomin')"
          >
            <i class="las la-search-plus"></i>
          </button>
          <button
            data-tip="Uzaklaş"
            class="hideOnMobile"
            @click="editorMenu('zoomout')"
          >
            <i class="las la-search-minus"></i>
          </button>
          <button
            data-tip="Katmanlar"
            class="hideOnMobile"
            :style="layersPanel ? 'background: #ccc;' : 'position: relative'"
            id="showMorePanelButton"
            @click="(layersPanel = !layersPanel), (layersInfo = false)"
          >
            <!-- <i class="las la-star"></i> -->
            <i class="noevent las la-layer-group"></i>
          </button>
          <button
            data-tip="Mesafe Ölç"
            class="hideOnMobile"
            :style="measurePanel ? 'background: #ccc;' : 'position: relative'"
            @click="editorMenu('measure'), (measurePanel = !measurePanel)"
          >
            <i class="noevent las la-ruler"></i>
          </button>
          <button
            data-tip="Yerimi Bul"
            id="showUserLocation"
            @click="displayUserLocation()"
          >
            <i class="las la-map-marked"></i>
          </button>
          <!-- <button id="showHUDButton" @click="displayHUD = !displayHUD"><i class="noevent las la-book-reader"></i></button> -->
          <button
            data-tip="Ekran Görüntüsü Al"
            id="showGraphDrawer"
            @click="captureMap()"
          >
            <i class="las la-camera"></i>
          </button>
          <button
            data-tip="Büyüklük-Zaman Grafiği Çiz"
            class="hideOnMobile"
            @click="regionForGraph()"
          >
            <i class="las la-chart-line"></i>
          </button>
          <button
            data-tip="Bildirimleri Aç"
            :style="notifyPanel ? 'background: #ccc;' : 'position: relative'"
            @click="notifyPanel = !notifyPanel"
          >
            <i class="las la-bell"></i>
          </button>
          <HudPanel id="hudPanel" v-show="displayHUD" />

          <select
            id="filterDateSelectionBox"
            @mouseenter="loadDateSelectionBox()"
            @change="filterDateSelection($event)"
          >
            <option
              v-for="date in this.filterDateRange"
              :key="date"
              :data-date="date.value"
              :formatted="date.formatted"
              :value="selectedDate"
            >
              {{ date.label }}
            </option>
          </select>
        </div>
        <div class="flex align-center">
          <button
            data-tip="Panoyu Aç/Kapat"
            data-anchor="right"
            @click="
              editorMenu('list'), (displayList = displayList ? false : true)
            "
            class="noselect"
          >
            <i class="las la-map"></i>
          </button>
        </div>
      </div>

      <p id="notice"></p>

      <aside class="noselect">
        <div v-if="layersPanel">
          <div class="topbar_extend">
            <span>Katmanlar</span>
            <div @click="plateChange($event)">
              <button
                id="layer_ginras"
                style="margin-right: 0.2vw"
                :style="this.layers.GINRAS ? 'background: #ccc;' : ''"
              >
                <i class="las"></i>GINRAS
              </button>
              <button
                id="layer_slab"
                style="margin-right: 0.2vw"
                :style="this.layers.SLAB2 ? 'background: #ccc;' : ''"
              >
                <i class="noselect las"></i>SLAB2
              </button>
              <button
                id="layer_risk"
                style="position: relative; margin-right: 0.2vw"
                :style="this.layers.RISK ? 'background: #ccc;' : ''"
              >
                <i class="noselect las"></i>AFAD
              </button>
              <button
                id="layer_tectonic"
                style="margin-right: 0.2vw"
                :style="this.layers.TECTONIC ? 'background: #ccc;' : ''"
              >
                <i class="las"></i>TEKTONİK
              </button>
              <button
                id="layer_volcanoes"
                style="margin-right: 0.2vw"
                :style="this.layers.VOLCANOES ? 'background: #ccc;' : ''"
              >
                <i class="las"></i>VOLKAN
              </button>
              <button @click="layersInfo = !layersInfo">
                <i class="noselect las la-info-circle"></i>
              </button>
            </div>
            <div v-show="layersInfo">
              <ol
                style="
                  margin: 0;
                  padding: clamp(0.5rem, 0.5vw, 1rem) clamp(1rem, 1vw, 2rem);
                "
              >
                <li>
                  GINRAS: Şu anda aktif olduğundan emin olunmayan ama bir
                  zamanlar aktif olduğu düşünülen/bilinen fayları da
                  içermektedir.
                </li>
                <li>
                  SLAB2: Dalan litosfer levhasının üst yüzeyinin derinlik
                  konturları.
                </li>
                <li>AFAD: Türkiye Deprem Tehlike Haritası</li>
              </ol>
            </div>
          </div>
        </div>
        <div v-if="measurePanel">
          <div class="topbar_extend">
            <span>Mesafe ölçümü</span>
            <div @click="measureChange($event)">
              <button id="measure_clear" style="margin-right: 0.2vw">
                Tümünü Sil
              </button>
              <button id="measure_drop" style="margin-right: 0.2vw">
                Tamamla (ESC)
              </button>
            </div>
          </div>
        </div>
        <div v-if="notifyPanel">
          <div class="topbar_extend">
            <span>Bildirimler</span>
            <div>
              <a
                href="http://x.com/SismikHarita"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button id="measure_clear" style="margin-right: 0.2vw">
                  𝕏 @SismikHarita
                </button>
                <!-- <i class="lab la-twitter" style="margin-right: .2vw;"></i> -->
              </a>
              <!-- <button @click="window.truepush.subscribeUserVapid()" id="measure_drop" style="margin-right: .2vw;" ><i class="lar la-bell" style="margin-right: .2vw;"></i>Tarayıcı Bildirimleri</button> -->
            </div>
          </div>
        </div>
      </aside>
    </aside>

    <aside id="topbar-extension"></aside>

    <div
      @click="mapClick($event)"
      class="containerMap"
      :class="{ noevent: stillLoading }"
    >
      <div style="height: 100%; width: 100vw; position: fixed" id="llmap"></div>
    </div>
  </section>
</template>

<script>
// console.log('QuakesMap.vue');
// import Swal from "sweetalert2";
import leaflet from "leaflet";
import plates from "@/assets/data/plates.json"; // credits: github/fraxen
import turkiye from "@/assets/data/turkiye.json"; // credits: github/wmgeolab

import HudPanel from "@/components/addons/HudPanel.vue";
import GraphComponent from "@/pages/GraphComponent.vue";
const GRAPH_ENDPOINT = process.env.VUE_APP_GRAPH_ENDPOINT;

import chroma from "chroma-js";
// import * as historicalData from '@/assets/data/historicalQuakes.json'; // credits: Onur TAN

import "leaflet.polylinemeasure/Leaflet.PolylineMeasure.css";
import "leaflet.polylinemeasure";
import "leaflet.locatecontrol";
import "leaflet-clicktolerance";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw/dist/leaflet.draw";
import "@ansur/leaflet-pulse-icon";
// import { SimpleMapScreenshoter } from "leaflet-simple-map-screenshoter";
import "leaflet-simple-map-screenshoter";

import riskMapImage from "@/assets/risk_2.svg";

// eslint-disable-next-line no-unused-vars
// import * as turf from "@turf/turf";

if (localStorage.getItem("dark") === "null")
  localStorage.setItem(
    "dark",
    window.matchMedia("(prefers-color-scheme: dark)").matches ? "true" : "false"
  );

import QuakesList from "./QuakesList.vue";
import { defineAsyncComponent } from "vue";

const PortalMenu = defineAsyncComponent({
  loader: () => import("@/pages/PortalPage.vue"),
});

const endpoint = process.env.VUE_APP_ENDPOINT;
const monthpoint = process.env.VUE_APP_MONTH;
const weekpoint = process.env.VUE_APP_WEEK;

let everyQuake = [];
// let thisWeek = [];
const limit = 1000;

const monthNames = {
  "01": "Ocak",
  "02": "Şubat",
  "03": "Mart",
  "04": "Nisan",
  "05": "Mayıs",
  "06": "Haziran",
  "07": "Temmuz",
  "08": "Ağustos",
  "09": "Eylül",
  10: "Ekim",
  11: "Kasım",
  12: "Aralık",
};

let URLPARAMETRE = new URL(window.location.href);

const queryString = window.location.search;
const params = new URLSearchParams(queryString);

let paramLoadDate = "";
export default {
  async setup() {
    // everyQuake = []
    // return
    // eslint-disable-next-line no-unreachable
    let today = null;
    let someDaysAgo = null;

    const fetchedData = [];

    // Check for URL params
    const pID = params.get("id");

    if (pID !== null) {
      const year = pID.substring(0, 4);
      const month = pID.substring(4, 6);

      someDaysAgo = new Date(
        new Date(year, parseInt(month - 1), 1).getTime() + 3 * 60 * 60 * 1000
      );
      today = new Date(
        new Date(year, parseInt(month - 1) + 1).getTime() + 3 * 60 * 60 * 1000
      );

      paramLoadDate = parseInt(`${year}${month}`);
    } else {
      // let daysBack = 7
      // const utcTime = new Date();
      // const gmt3Time = new Date(utcTime.getTime() + (3 * 60 * 60 * 1000));
      // today = gmt3Time;
      // someDaysAgo = new Date(new Date().getTime() - (daysBack * 24 * 60 * 60 * 1000));

      const response = await fetch(`${weekpoint}`);
      const data = await response.json();
      fetchedData.push([...data.results]);

      everyQuake = fetchedData.flat();
      return;
    }
    // URL params

    // console.log('fetching');
    let totalPages = 1;
    let currentPage = 1;

    const fetchPages = async () => {
      while (currentPage <= totalPages) {
        const url = `${endpoint}?sdate=${someDaysAgo.toISOString()}&edate=${today.toISOString()}&limit=${limit}&page=${currentPage}`;
        const response = await fetch(url);
        const data = await response.json();
        fetchedData.push([...data.results]);
        totalPages = data.total_pages;
        currentPage++;
      }

      everyQuake = fetchedData.flat();
    };

    // eslint-disable-next-line no-unreachable
    await fetchPages();

    // if (pID !== null) {
    //   thisWeek = everyQuake;
    // }
  },
  name: "MapComponent",
  components: {
    QuakesList,
    PortalMenu,
    HudPanel,
    GraphComponent,
  },
  props: {
    selectedDate: String,
  },
  data() {
    return {
      isDark: localStorage.getItem("dark") === "true" ? true : false,
      cityClick: JSON.parse(localStorage.getItem("cityClick")) || null,
      stillLoading: true,
      quakeData: [],
      markerData: [],
      settings: {
        quakeLimit: "500",
        quakeMl: "0",
        quakeDays: "365",
      },
      quakeLast: undefined,
      quakeListInstance: 0,
      quakeListRecent: true,
      pID: "",
      pLoc: {},
      clientLocation: [0, 0],
      filterLocations: [],
      canDisplayList: false,
      canDisplayPortal: false,
      continuity: {
        w: 0,
        h: 0,
      },
      mapOptions: {
        center: [38.5, 40],
        zoom: 5,
        // url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
        url:
          localStorage.getItem("dark") === "true"
            ? "https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}" //"https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
            : "https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}",
      },
      measureOptions: {
        position: "bottomright",
        unit: "metres",
        clearMeasurementsOnStop: false,
        showClearControl: true,
        showUnitControl: false,
        tooltipTextFinish: "<b>Sonlandırmak için</b> tıklayın.<br>",
        tooltipTextDelete: "<b>Durağı silmek için</b> SHIFT tuşuna basın.",
        tooltipTextMove: "<b>Durağı sürüklemek için</b> basılı tutun. <br>",
        tooltipTextResume: "<br><b>Devam etmek için</b> CTRL tuşuna basın.",
        tooltipTextAdd:
          "<b>Durak eklemek için</b> CTRL tuşuna basın ve tıklayın.",
        measureControlTitleOn: "Polyline Aç",
        measureControlTitleOff: "Polyline Kapat",
        clearControlTitle: "Temizle",
        unitControlTitle: {
          text: "Birimi değiştir",
          metres: "metre",
          landmiles: "kara mili",
          nauticalmiles: "deniz mili",
        },
      },
      measuring: false,
      displayHUD: false,
      displayList: true,
      displayLegend: true,
      displayQuickSettings: false,
      layersPanel: false,
      layersInfo: false,
      measurePanel: false,
      notifyPanel: false,
      graphView: false,
      graphLoaded: { sdate: null, edate: null, minMag: null, maxMag: null },
      graphBoundaries: {
        minLat: 17.49,
        maxLat: 52.471,
        minLon: 29.626,
        maxLon: 46.085,
      },
      filterDateRange: [
        { label: "Son 7 Gün", value: "Son 7 Gün" },
        // { label: "Son 6 Ay", value: "6M" },
        // { label: "Son 12 Ay", value: "12M" },
      ],
      filterDateLoaded: false,
      allowMapClick: true,
      layers: {
        GINRAS: false,
        SLAB2: false,
        RISK: false,
        TECTONIC: false,
        VOLCANOES: false,
      },
    };
  },

  methods: {
    darkModeSwitch() {
      localStorage.setItem("dark", (!this.isDark).toString());
      window.location.reload();
    },
    // setTheme() {
    //   return window.matchMedia("(prefers-color-scheme: dark)").matches
    //     ? "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.{ext}"
    //     : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";
    // },
    async generateGraph(selectedDate, minMag = 0, maxMag = 10, boundaries) {
      if (
        JSON.stringify({ selectedDate, minMag, maxMag, boundaries }) ===
        JSON.stringify(this.graphLoaded)
      ) {
        this.graphView = true;
        return;
      }

      let today;
      let someDaysAgo;
      if (isNaN(selectedDate[0])) {
        let daysBack = 7;
        const utcTime = new Date();
        const gmt3Time = new Date(utcTime.getTime() + 3 * 60 * 60 * 1000);
        today = gmt3Time;
        someDaysAgo = new Date(
          new Date().getTime() - daysBack * 24 * 60 * 60 * 1000
        );
      } else {
        let year, month;

        const parseDate = function () {
          year = parseInt(selectedDate.substring(0, 4));
          month = parseInt(selectedDate.substring(4, 6)) - 1;
        };

        parseDate();
        let firstDayOfMonth = new Date(
          new Date(year, month, 1).getTime() + 3 * 60 * 60 * 1000
        );
        let lastDayOfMonth = new Date(
          new Date(year, month + 1).getTime() + 3 * 60 * 60 * 1000
        );
        today = new Date(lastDayOfMonth);
        someDaysAgo = new Date(firstDayOfMonth);
      }

      this.graphLoaded = { selectedDate, minMag, maxMag, boundaries };
      if (this.drawnItemslayer)
        this.drawnItems.removeLayer(this.drawnItemslayer);

      await fetch(
        `${GRAPH_ENDPOINT}?sdate=${someDaysAgo.toISOString()}&edate=${today.toISOString()}&minMag=${
          minMag - 0.1
        }&maxMag=${maxMag + 0.1}&minLat=${boundaries.minLat}&maxLat=${
          boundaries.maxLat
        }&minLon=${boundaries.minLon}&maxLon=${boundaries.maxLon}`
      )
        .then((r) => r.text())
        .then(
          (data) => {
            this.graphContent = data;
            this.graphView = true;
          },
          // eslint-disable-next-line no-unused-vars
          (response) => {
            console.log("Graph error.");
          }
        );
    },
    async applyUpdates() {
      await this.fetchMarkerData();
      await this.putMarkers();
      this.stillLoading = false;
      this.quakeListInstance++;

      document.querySelector("#loadingList").classList.add("inactive");

      if (this.pID) {
        const ID = this.pID;

        if (paramLoadDate) {
          this.$nextTick(() => {
            const optionElement = document.querySelector(
              "#filterDateSelectionBox"
            );
            const option = optionElement.querySelector(
              `option[data-date='${paramLoadDate}']`
            );
            option.selected = true;
          });
        }

        this.llmap.eachLayer(function (layer) {
          if (layer instanceof leaflet.CircleMarker) {
            if (layer.options.dataAttribute === ID) {
              layer.openPopup();
              layer.setStyle({ opacity: 1, fillOpacity: 1, interactive: true });
            } else {
              layer.closePopup();
              layer.setStyle({
                opacity: 0,
                fillOpacity: 0,
                interactive: false,
              });
            }
          }
        });

        if (this.pLoc.lat) {
          this.llmap.setView([this.pLoc.lat, this.pLoc.lon], 9);

          // const paramMarker = leaflet.circle([this.pLoc.lat, this.pLoc.lon], {
          //   radius: 200 ** 2,
          //   fillOpacity: 1,
          //   color: 'blue',
          //   weight: 2,
          //   fillColor: 'transparent',
          //   opacity: 1,
          //   interactive: false,
          //   preferCanvas: false,
          // })
          // paramMarker.addTo(this.llmap)
          return;
        }
      }
    },
    async cleanData() {
      document.querySelector("#loadingList").classList.remove("inactive");
      everyQuake = [];
      this.quakeData = [];
      this.markerData = [];
    },
    async loadOneWeek() {
      // let daysBack = 7
      // const utcTime = new Date();
      // const gmt3Time = new Date(utcTime.getTime() + (3 * 60 * 60 * 1000));
      // let today = gmt3Time;
      // let someDaysAgo = new Date(new Date().getTime() - (daysBack * 24 * 60 * 60 * 1000));

      // let totalPages = 1;
      // let currentPage = 1;

      // const fetchedData = [];
      // const fetchPages = async () => {
      //   while (currentPage <= totalPages) {
      //     const url = `${endpoint}?sdate=${someDaysAgo.toISOString()}&edate=${today.toISOString()}&limit=${limit}&page=${currentPage}`;
      //     const response = await fetch(url);
      //     const data = await response.json();
      //     fetchedData.push([...data.results])
      //     totalPages = data.total_pages;
      //     currentPage++;
      //   }

      //   everyQuake = fetchedData.flat()
      // };

      // await fetchPages();
      // thisWeek = everyQuake
      let fetchedData = [];
      const response = await fetch(weekpoint);
      const data = await response.json();
      fetchedData.push([...data.results]);

      everyQuake = fetchedData.flat();
      return;
    },
    async loadMonths(value) {
      paramLoadDate = value + "M";
      await this.cleanData();
      let fetchedData = [];
      const response = await fetch(monthpoint + "?months=" + value);
      const data = await response.json();
      fetchedData.push([...data.results]);

      everyQuake = fetchedData.flat();
      this.quakeListRecent = true;
      await this.applyUpdates();
    },
    async loadThisWeek() {
      paramLoadDate = "Son 7 Gün";
      await this.cleanData();
      await this.loadOneWeek();
      this.quakeListRecent = true;
      await this.applyUpdates();
    },
    async loadSelectedMonth(sdate, edate) {
      this.quakeListRecent = false;
      history.pushState(null, "", "/");

      const fetchedData = [];
      const fetchPages = async () => {
        let totalPages = 1;
        let currentPage = 1;

        while (currentPage <= totalPages) {
          const url = `${endpoint}?sdate=${sdate}&edate=${edate}&limit=${limit}&page=${currentPage}`;
          const response = await fetch(url);
          const data = await response.json();
          fetchedData.push([...data.results]);
          // console.log([...data.results]);
          totalPages = data.total_pages;
          currentPage++;
        }

        everyQuake = fetchedData.flat();
      };

      await fetchPages();
      await this.applyUpdates();
    },
    async applyDateSelection(selected) {
      await this.cleanData();

      this.displayList = true;
      if (selected === "Son 7 Gün") {
        this.loadThisWeek();
        return;
      } else if (selected === "6M") {
        this.loadMonths(6);
        return;
      } else if (selected === "12M") {
        this.loadMonths(12);
        return;
      } else {
        let year, month, firstDayOfMonth, lastDayOfMonth;

        const parseDate = function () {
          year = parseInt(selected.substring(0, 4));
          month = parseInt(selected.substring(4, 6)) - 1;
        };

        // if (
        //   !selected.includes("a") &&
        //   !selected.includes("b") &&
        //   !selected.includes("c")
        // ) {
        parseDate();
        firstDayOfMonth = new Date(
          new Date(year, month, 1).getTime() + 3 * 60 * 60 * 1000
        );
        lastDayOfMonth = new Date(
          new Date(year, month + 1).getTime() + 3 * 60 * 60 * 1000
        );
        // }

        // if (selected.includes("a")) {
        //   selected = selected.slice(0, -1);
        //   parseDate();

        //   firstDayOfMonth = new Date(
        //     new Date(year, month, 1).getTime() + 3 * 60 * 60 * 1000
        //   );
        //   lastDayOfMonth = new Date(
        //     new Date(year, month, 7).getTime() + 3 * 60 * 60 * 1000
        //   );
        // }
        // if (selected.includes("b")) {
        //   selected = selected.slice(0, -1);
        //   parseDate();

        //   firstDayOfMonth = new Date(
        //     new Date(year, month, 14).getTime() + 3 * 60 * 60 * 1000
        //   );
        //   lastDayOfMonth = new Date(
        //     new Date(year, month, 21).getTime() + 3 * 60 * 60 * 1000
        //   );
        // }
        // if (selected.includes("c")) {
        //   selected = selected.slice(0, -1);
        //   parseDate();

        //   firstDayOfMonth = new Date(
        //     new Date(year, month, 21).getTime() + 3 * 60 * 60 * 1000
        //   );
        //   lastDayOfMonth = new Date(
        //     new Date(year, month + 1).getTime() + 3 * 60 * 60 * 1000
        //   );
        // }
        paramLoadDate = `${year}${month}`;
        await this.loadSelectedMonth(
          firstDayOfMonth.toISOString(),
          lastDayOfMonth.toISOString()
        );
      }
    },
    async init() {
      this.llmap = leaflet
        .map("llmap", { renderer: leaflet.canvas(), preferCanvas: true })
        .setView(this.mapOptions.center, this.mapOptions.zoom);
      leaflet
        .tileLayer(this.mapOptions.url, {
          attribution:
            localStorage.getItem("dark") === "true"
              ? 'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>' //'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
              : 'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>',
          subdomains: "abcd",
          maxZoom: 16,
          minZoom: 4,
        })
        .addTo(this.llmap);

      // const southWest = leaflet.latLng(35.878592, 25.667405);
      // const northEast = leaflet.latLng(42.107614, 44.793331);
      // const bounds = leaflet.latLngBounds(southWest, northEast);

      // this.llmap.value.setMaxBounds(bounds);

      this.llmap.on("zoomend", () => {
        if (this.llmap.getZoom() < 4) {
          this.llmap.setZoom(4);
        }
      });

      this.llmap.attributionControl.setPosition("bottomleft");

      this.measurer = leaflet.control
        .polylineMeasure(this.measureOptions)
        .addTo(this.llmap);
      this.llMarkerLayer = leaflet.layerGroup().addTo(this.llmap);

      const drawControl = new leaflet.Control.Draw({
        position: "topleft",
        draw: {
          rectangle: true,
          polygon: false,
          circle: false,
          circlemarker: false,
          marker: false,
          polyline: false,
        },
        edit: false,
      });
      this.llmap.addControl(drawControl);

      document.querySelector(".leaflet-draw-toolbar").style.visibility =
        "hidden";

      this.drawnItems = new leaflet.FeatureGroup().addTo(this.llmap);
      this.llmap.on(
        "draw:created",
        function (event) {
          document.querySelector("#loadingList").classList.remove("inactive");
          this.allowMapClick = false;
          this.drawnItems.clearLayers();

          this.drawnItemslayer = event.layer;
          let bounds = this.drawnItemslayer.getBounds();
          let minLatLng = bounds.getSouthWest();
          let maxLatLng = bounds.getNorthEast();

          let minLat = minLatLng.lat;
          let minLon = minLatLng.lng;
          let maxLat = maxLatLng.lat;
          let maxLon = maxLatLng.lng;

          this.graphBoundaries = { minLat, maxLat, minLon, maxLon };

          this.drawnItems.addLayer(this.drawnItemslayer);
          document.querySelector("#sidebar").classList.add("show");
          this.$nextTick(async () => {
            const dateSelectionBox = document.querySelector(
              "#filterDateSelectionBox"
            );
            const theDate =
              dateSelectionBox.options[
                dateSelectionBox.selectedIndex
              ].getAttribute("data-date");

            const [minML, maxML] = document
              .querySelector("#filterMlRange")
              .querySelector("h5")
              .textContent.split(" ")[0]
              .split("-");

            await this.generateGraph(
              theDate,
              minML,
              maxML,
              this.graphBoundaries
            );
            this.allowMapClick = true;

            document.querySelector("#loadingList").classList.add("inactive");
          });
        }.bind(this)
      );

      // Disable automatic click behavior when drawing ends
      this.llmap.on(
        "draw:drawstop",
        function () {
          this.llmap.dragging.enable();
        }.bind(this)
      );

      // Enable manual click to finish drawing
      this.llmap.on(
        "draw:drawstart",
        function () {
          this.llmap.dragging.disable();
          this.allowMapClick = false;
        }.bind(this)
      );

      this.llLayerGroup = leaflet.featureGroup().addTo(this.llmap);

      let pluginOptions = {
        cropImageByInnerWH: true,
        hidden: false,
        preventDownload: false,
        domtoimageOptions: {},
        position: "topleft",
        screenName: "SismikHarita",
        hideElementsWithSelectors: [".leaflet-control-container"],
        mimeType: "image/png",
        caption: `${new Date().getFullYear()} © Sismik Harita by Evrim Ağacı`,
        captionFontSize: 15,
        captionFont: "Arial",
        captionColor: "black",
        captionBgColor: "white",
        captionOffset: 5,
      };

      this.simpleMapScreenshoter = leaflet
        .simpleMapScreenshoter(pluginOptions)
        .addTo(this.llmap);
      let format = "blob";
      let overridedPluginOptions = {
        mimeType: "image/jpeg",
      };
      this.simpleMapScreenshoter
        .takeScreen(format, overridedPluginOptions)
        // eslint-disable-next-line no-unused-vars
        .then((blob) => {
          // alert(blob);
          // FileSaver.saveAs(blob, 'screen.png')
        })
        .catch((e) => {
          console.error(e);
        });

      document.querySelector(
        ".leaflet-control-simpleMapScreenshoter"
      ).style.visibility = "hidden";

      this.locationProvider = leaflet.control
        .locate({
          position: "bottomleft",
          setView: false,
          strings: {
            title: "Konum izni ver",
          },
          showPopup: false,
          locateOptions: {
            enableHighAccuracy: true,
          },
        })
        .addTo(this.llmap);

      // // Create a divIcon to be used as a button on the map
      // const buttonIcon = leaflet.divIcon({
      //   className: "map-button",
      //   html: `<i style="font-size: 1rem; background: ${this.adaptiveColor(
      //     "#fff"
      //   )}; color: ${this.adaptiveColor(
      //     "#000"
      //   )}; border: 1px solid ${this.adaptiveColor(
      //     "#000"
      //   )}; border-radius: .5rem; padding: .5rem;" class="noevent las la-layer-group"></i>`,
      //   iconSize: [100, 40], // Adjust the size of the button
      //   iconAnchor: [50, 20], // Position the button in the center
      // });

      // // Place the button on the map at a specific latitude and longitude
      // const buttonMarker = leaflet
      //   .marker([43.93565, 34.076335], {
      //     icon: buttonIcon,
      //   })
      //   .addTo(this.llmap);

      // // Add event listener to handle click action
      // buttonMarker.on("click", function () {
      //   alert("Button on the map clicked!");
      // });

      const onCityClick = function (
        e,
        mapInstance,
        layer,
        feature,
        originalStyle
      ) {
        if (!this.allowMapClick) return;
        if (!this.cityClick) {
          return;
        }

        let cityName = feature.properties.shapeName;

        const searchBarElement = document.querySelector("#filterSearchInput");
        if (searchBarElement.value === cityName) {
          searchBarElement.value = "";
          searchBarElement.dispatchEvent(new Event("input"));
          layer.setStyle(originalStyle);

          mapInstance.setView([38.5, 40], 5);
          return;
        }

        mapInstance.setView(e.latlng, 8);
        searchBarElement.value = cityName;
        searchBarElement.dispatchEvent(new Event("input"));
      }.bind(this);

      this.TurkiyeBorders = leaflet.geoJSON(turkiye, {
        style: { color: "transparent", weight: "0", fillOpacity: "0" },
        onEachFeature: function (feature, layer) {
          const originalStyle = layer.options.style;
          layer.bindTooltip(
            `
            <div style="font-family: 'NunitoSans';">
              ${feature.properties.shapeName}
            </div>
            `,
            {
              width: "420",
            }
          );

          const mapInstance = this.llmap;
          layer.on("mouseover", function () {
            layer.setStyle({
              weight: "1",
              color: "gray",
              opacity: 0.5,
              fillOpacity: 0.2,
            });
          });
          layer.on("mouseout", function () {
            layer.setStyle(originalStyle);
          });
          layer.on("click", function (e) {
            if (e.originalEvent.pointerType !== "mouse") return;
            onCityClick(e, mapInstance, layer, feature, originalStyle);
          });
        }.bind(this),
      });
      this.TurkiyeBorders.addTo(this.llmap);

      this.TurkiyeBorders.bringToBack();

      this.llmap.zoomControl.remove();
      leaflet.control
        .zoom({
          position: "bottomleft",
        })
        .addTo(this.llmap);

      document.querySelector(".leaflet-control-zoom").style.left = "-100%";
      document.querySelector(".leaflet-control-locate").style.left = "-100%";

      this.geojsonPlates = leaflet.geoJSON(plates, {
        style: { color: "#7d2e1f", weight: ".3", opacity: 1, fillOpacity: "1" },
        // , clickTolerance: 2
        // onEachFeature: function(feature, layer) {
        //   if (feature.properties.FID) {
        //     let originalStyle
        //     if (!originalStyle) originalStyle = layer.options.style;
        //     layer.bindPopup(`
        //       <div style="font-family: 'NunitoSans';">
        //         FID: ${feature.properties.FID}
        //       </div>
        //       `, {
        //         width: '420',
        //         className: 'custom-popup'
        //     });
        //     // layer.on('click', function(e) {
        //     //   console.log(feature, e);
        //     // });
        //     layer.on('mouseover', function() {
        //       layer.setStyle({ weight: '3', color: 'red' })
        //     })

        //     layer.on('mouseout', function() {
        //       layer.setStyle(originalStyle)
        //     })
        //   }
        // }
      });
      this.geojsonPlates.options.interactive = true;
      this.geojsonPlates.addTo(this.llmap);

      this.canDisplayList = true;

      await this.applyUpdates();
    },
    async fetchMarkerData() {
      this.filterLocations = [];

      everyQuake.forEach((quake) => {
        let id = quake.id;

        this.quakeData.push({ id: id, body: quake.body });
        this.markerData.push({ id: id, body: quake.body });
      });

      this.filterLocations.sort((a, b) =>
        a.toLowerCase() > b.toLowerCase() ? 1 : -1
      );
      this.filterLocations.shift();

      this.quakeData.sort(function (a, b) {
        const date2 = new Date(a.body[0].tarih);
        const date1 = new Date(b.body[0].tarih);

        return date1 - date2;
      });
    },
    displayUserLocation() {
      this.locationProvider.start();
    },
    colorize(depth) {
      switch (true) {
        case depth <= 5:
          return "#8b0000";
        case depth <= 10:
          return "#FF0000";
        case depth <= 20:
          return "#FF7F01";
        case depth <= 40:
          return "#FBE955";
        case depth <= 80:
          return "#74FB55";
        default:
          return "#33DAE9";
      }
    },
    async putMarkers() {
      this.llMarkerLayer.clearLayers();

      let recentQuake = {};

      const len = this.markerData.length;

      for (let i = 0; i < len; i++) {
        const theQuake = this.markerData[i];
        const { buyukluk, derinlik, enlem, boylam } = theQuake.body[0];

        const r = buyukluk < 4 ? buyukluk * 1.5 : buyukluk * 1.9;
        // const r = buyukluk >= 4.5 ? Math.pow(1.7, buyukluk) : buyukluk > 3 ? buyukluk * 2 : buyukluk * 1.2;

        // const magnitudeRadiusMap = [2, 3, 5, 6, 7, 8, 9, 10, 11]; // Define custom radius values for magnitudes 1-6
        // const r = magnitudeRadiusMap[Math.floor(buyukluk) - 1];

        const color = this.colorize(derinlik);

        let colorCode = "green";

        const colorizeByMg = function (buyukluk) {
          return buyukluk >= 4 ? "red" : buyukluk > 3 ? "orange" : "green";
        };

        colorCode = colorizeByMg(buyukluk);

        let circleMarker;
        const quakeDate = new Date(theQuake.body[0].tarih);
        const now = new Date();
        const dif = Math.abs((quakeDate.getTime() - now.getTime()) / 1000);

        if (i == 0 && dif < 3600) {
          let pulsingIcon = leaflet.icon.pulse({
            iconSize: [r * 2.4, r * 2.4],
            color: color,
            fillColor: color,
            heartbeat: 3,
          });
          circleMarker = leaflet
            .marker([enlem, boylam], { icon: pulsingIcon })
            .addTo(this.llMarkerLayer);

          // leaflet.marker([enlem, boylam]).addTo(this.llmap);
        } else {
          circleMarker = leaflet.circleMarker([enlem, boylam], {
            radius: r,
            color: "#000",
            weight: buyukluk < 3 ? 0.5 : 1,
            fillColor: color,
            fillOpacity: 1,
            dataAttribute: theQuake.id,
            zIndex: buyukluk * 1,
            maxZoom: 5,
            clickTolerance: buyukluk < 3 ? 3 : 1,
          });

          circleMarker.setStyle({
            opacity: 1,
            fillOpacity: 1,
            interactive: true,
          });
        }

        if (theQuake.id == this.quakeData[0].id) {
          recentQuake.marker = circleMarker;
          recentQuake.r = r;
          recentQuake.coor = [enlem, boylam];
        }

        const allQuakes = [];
        for (let i = 1; i < theQuake.body.length; i++) {
          const strTarih = new Date(theQuake.body[0].tarih).toLocaleString(
            "tr"
          );
          // allQuakes.push(`<p>${theQuake.body[i].veriKaynagi} <span style="margin: 0; margin-right: .5rem; font-size: normal; color: ${colorCode};"><span style="margin: 0; font-size: small;">${theQuake.body[i].yontem}</span>${theQuake.body[i].buyukluk.replace('.',',')}</span></p>`)
          allQuakes.push(`
            <div class="popupItem align-center flex font-family: 'NunitoSans'; flex-between" style="margin-top: 5px; margin: 0; font-weight: lighter;">
              <div>
                <h4 style="float:left; margin: 0; margin-right: .5rem; font-size: normal; color: ${colorizeByMg(
                  theQuake.body[i].buyukluk
                )};"><span style="font-size: xx-small;">${
            theQuake.body[i].yontem
          }</span>${theQuake.body[i].buyukluk.replace(".", ",")}</h4>
                <span style="margin: 0; font-size: x-small;">${
                  theQuake.body[i].veriKaynagi
                }</span>
              </div>
              <h5 style="margin: 0;">${theQuake.body[i].derinlik} km ${
            strTarih.split(" ")[1]
          }</h5>
            </div>
          `);
        }

        const strTarih = quakeDate.toLocaleString("tr");

        if (!this.is_touch_device()) {
          circleMarker.bindTooltip(
            `<h2 style="margin: 0; display:inline; font-size: large; color: ${colorCode};"><span style="margin: 0; font-size: xx-small;">${
              theQuake.body[0].yontem
            }</span><b>${buyukluk.replace(".", ",")}</b></h2> — ${
              theQuake.body[0].yer
            } — ${strTarih}`
          );
        }

        circleMarker.bindPopup(
          `
          <div class="flex flex-column" style="font-family: 'NunitoSans'; margin-bottom: .5rem;">
            <h2 style="margin: 0; margin-bottom: .5rem;">${
              theQuake.body[0].yer
            }</h2>
            <div>
              <div style="margin-bottom: 5px;" class="flex flex-row align-center">
                <h2 style="margin: 0; margin-right: .5rem; font-size: x-large; color: ${colorCode};"><span style="margin: 0; font-size: small;">${
            theQuake.body[0].yontem
          }</span>${buyukluk.replace(".", ",")}</h2>

                <div class="align-center" style="flex: 1;">
                  <h5 style="margin: 0;">${theQuake.body[0].veriKaynagi}</h5>
                  <h5 style="margin: 0;">Derinlik: ${derinlik} km</h5>
                  <h5 style="margin: 0;">Tarih: ${strTarih}</h5>
                </div>
              </div>
              ` +
            allQuakes.join("\n") +
            `
            </div>
          </div>
          <div class="flex-between">
            <a data-coord='${enlem},${boylam}' class='displayOnZoomButton ${enlem}-${boylam}'><i class="las la-search-plus"></i> Yakınlaş</a>
          </div>
          `,
          {
            width: "420",
            className: "custom-popup",
          }
        );

        circleMarker.on("click", function () {
          URLPARAMETRE.searchParams.set("lat", enlem);
          URLPARAMETRE.searchParams.set("lon", boylam);
          URLPARAMETRE.searchParams.set("id", theQuake.id);

          history.pushState(null, "", URLPARAMETRE.toString());
        });

        this.llMarkerLayer.addLayer(circleMarker);
        // <a data-popup='${theQuake.id}' class='displayOnListButton'><i class="las la-bars"></i> Listede göster</a>
        // circleMarker.addTo(this.llMarkerLayer)
      }

      this.markerData = [];
    },
    createCircleIcon(color, radius) {
      const iconSize = 2 * radius + 2; // Fixed icon size based on radius
      return leaflet.divIcon({
        className: "circle-icon",
        html: `<svg width="${iconSize}" height="${iconSize}">
                <circle cx="${radius + 1}" cy="${
          radius + 1
        }" r="${radius}" fill="${color}" />
              </svg>`,
        iconSize: [iconSize, iconSize],
      });
    },
    filterSortMethodByDate() {
      // Deprem tarih sıralamsı
      this.quakeData.sort(function (a, b) {
        const date2 = new Date(a.body.tarih);
        const date1 = new Date(b.body.tarih);

        return date1 - date2;
      });
    },
    compareWords(word1, word2) {
      return (
        word1?.toLowerCase().replace(/ğ/g, "g").replace(/ş/g, "s") ===
        word2?.toLowerCase().replace(/ğ/g, "g").replace(/ş/g, "s")
      );
    },
    is_touch_device() {
      return (
        "ontouchstart" in window ||
        navigator.MaxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
    },
    listShow(state = 2) {
      const sidebar = document.querySelector("#sidebar");
      if (state === 2) {
        sidebar.classList.contains("show")
          ? sidebar.classList.remove("show")
          : sidebar.classList.add("show");
      }
      if (state === 1) {
        sidebar.classList.add("show");
      }
      if (state === 0) {
        sidebar.classList.remove("show");
      }
    },
    editorMenu(nav) {
      switch (nav) {
        case "portal":
          this.canDisplayPortal = !this.canDisplayPortal;
          break;
        case "list":
          this.displayList
            ? document.querySelector("#sidebar").classList.remove("show")
            : document.querySelector("#sidebar").classList.add("show");

          // if (this.displayList) {
          //   document.querySelector('#topbar').style.width = '100%';
          // } else document.querySelector('#topbar').style.width = 'calc(100% - 25rem)';
          break;
        case "zoomin":
          document.querySelector(".leaflet-control-zoom-in").click();
          break;
        case "zoomout":
          document.querySelector(".leaflet-control-zoom-out").click();
          break;
        case "measure":
          document
            .getElementById("polyline-measure-control")
            .parentElement.classList.toggle("inactive");
          document.getElementById("polyline-measure-control").click();
          this.measuring = !this.measuring;

          if (this.measuring) {
            this.llmap.removeLayer(this.TurkiyeBorders);
          } else this.llmap.addLayer(this.TurkiyeBorders);
          break;
      }
    },
    captureMap() {
      document
        .querySelector(".leaflet-control-simpleMapScreenshoter-btn")
        .click();
    },
    regionForGraph() {
      document.querySelector("#sidebar").classList.remove("show");
      document.querySelector(".leaflet-draw-draw-rectangle").click();
    },
    async windowResize() {
      const list = document.querySelector("#sidebar");
      if (window.innerWidth > "600") {
        list.classList.add("show");
        this.displayList = true;
        // document.querySelector('#topbar').style.width = 'calc(100% - 25rem)';
        this.mapOptions.center = [38.5, 40];
        this.llmap.setView(this.mapOptions.center, this.mapOptions.zoom);

        if (window.innerWidth > "2048") {
          this.mapOptions.zoom = 6;
          this.llmap.setView(this.mapOptions.center, this.mapOptions.zoom);
        }

        if (window.innerWidth > "3800") {
          this.mapOptions.zoom = 7;
          this.llmap.setView(this.mapOptions.center, this.mapOptions.zoom);
        }
      } else {
        this.displayList = false;
        // document.querySelector('#topbar').style.width = '100%';
        this.mapOptions.center = [38.5, 34];
        this.llmap.setView(this.mapOptions.center, 4);
      }
    },
    async mapClick(event) {
      if (event.target.classList.contains("displayOnListButton")) {
        this.listShow(1);
        let chosenQuakeID = event.target.getAttribute("data-popup");
        let chosenQuake = document
          .querySelector(".containerList")
          .querySelector(`[data-quake="${chosenQuakeID}"]`);

        document.querySelector("#loadingList").classList.remove("inactive");
        while (!chosenQuake) {
          chosenQuake = document
            .querySelector(".containerList")
            .querySelector(`[data-quake="${chosenQuakeID}"]`);
          if (!chosenQuake) {
            // Scroll to the containerList element if the chosenQuake element isn't found
            document.querySelector("#endOfList").scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "end",
            });
            await new Promise((resolve) => setTimeout(resolve, 250)); // wait for the scroll animation to finish
          }
        }
        document.querySelector("#loadingList").classList.add("inactive");

        chosenQuake.parentElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
        chosenQuake.parentElement.click();
        chosenQuake.parentElement.classList.add("highlight");
        return;
      }
      if (event.target.classList.contains("displayOnZoomButton")) {
        const [enlem, boylam] = event.target.classList[1].split("-");
        if (
          this.llmap.getCenter().lat == enlem &&
          this.llmap.getCenter().lng == boylam
        ) {
          this.editorMenu("zoomin");
        } else {
          this.llmap.setView([enlem, boylam], 8);
        }
      }

      if (!event.target.classList.contains("mapMarker")) return;

      const allMarkers = document.querySelectorAll(".llmapMarker");
      if (event.target.parentElement.classList.contains("highlight")) {
        allMarkers.forEach((marker) => marker.classList.remove("invisible"));
        event.target.parentElement.classList.remove("highlight");
        event.target.classList.remove("chosenQuake");

        return;
      }

      allMarkers.forEach(function (marker) {
        if (marker === event.target) {
          marker.classList.remove("invisible");
          marker.style.filter = "scale(10)";
          marker.parentElement.classList.add("highlight");
          marker.classList.add("chosenQuake");
        } else {
          marker.classList.add("invisible");
          marker.parentElement.classList.remove("highlight");
        }
      });

      this.listShow(1);
      let chosenQuakeID = event.target.getAttribute("data-quake");
      let chosenQuake = document
        .querySelector(".containerList")
        .querySelector(`[data-quake="${chosenQuakeID}"]`);
      chosenQuake.parentElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      chosenQuake.parentElement.classList.add("highlight");
    },
    async plateChange(event) {
      const coords = this.llmap.getCenter();
      let setting = event.target.id.split("_")[1];

      if (setting === "slab") {
        // SLAB
        if (!this.geojsonSlab) {
          const slab = await import("@/assets/data/slab.json"); // credits: mail?
          let colorScale = chroma
            .scale(["red", "orange", "yellow", "limegreen"])
            .domain([0, 400]);
          this.geojsonSlab = new leaflet.GeoJSON(slab, {
            style: { weight: "1.4" },
            onEachFeature: function (feature, layer) {
              layer.bindTooltip(feature.properties.Name);

              let color = colorScale(feature.properties.DEPTH).rgb();

              layer.setStyle({
                color: `rgb(${color[0]}, ${color[1]}, ${color[2]})`,
              });
            },
          });
        }
        this.llLayerGroup.hasLayer(this.geojsonSlab)
          ? this.llLayerGroup.removeLayer(this.geojsonSlab)
          : this.llLayerGroup.addLayer(this.geojsonSlab);

        this.layers.SLAB2 = !this.layers.SLAB2;
      }

      if (setting === "ginras") {
        if (!this.geojsonAdvancedPlates) {
          const advancedPlates = await import("@/assets/data/plates_full.json"); // credits: neotec.ginras.ru
          // GINRAS FAY
          this.geojsonAdvancedPlates = new leaflet.GeoJSON(advancedPlates, {
            style: {
              color: this.adaptiveColor("#000"),
              weight: ".5",
              fillOpacity: "0",
            },
          });
        }
        this.llLayerGroup.hasLayer(this.geojsonAdvancedPlates)
          ? this.llLayerGroup.removeLayer(this.geojsonAdvancedPlates)
          : this.llLayerGroup.addLayer(this.geojsonAdvancedPlates);

        this.layers.GINRAS = !this.layers.GINRAS;
      }

      if (setting === "risk") {
        if (!this.riskMapLayer) {
          // RİSK HARİTASI

          // V1
          // const southWest = leaflet.latLng(35.878592, 25.667405);
          // const northEast = leaflet.latLng(42.107614, 44.793331);

          // V2
          const southWest = leaflet.latLng(35.178592, 25.417405);
          const northEast = leaflet.latLng(43.037614, 45.153331);
          const bounds = leaflet.latLngBounds(southWest, northEast);

          // this.layers.RISK =
          // .addTo(this.llmap);
          this.riskMapLayer = new leaflet.imageOverlay(riskMapImage, bounds, {
            opacity: 0.8,
          });
        }
        this.llLayerGroup.hasLayer(this.riskMapLayer)
          ? this.llLayerGroup.removeLayer(this.riskMapLayer)
          : this.llLayerGroup.addLayer(this.riskMapLayer);

        this.layers.RISK = !this.layers.RISK;

        if (!this.layers.RISK) {
          document.querySelector("#notice").textContent = "";
          document.querySelector("#notice").style.visibility = "hidden";
        } else {
          document.querySelector("#notice").textContent =
            "Katman Kaynağı: TBDY (2018). AFAD - Türkiye Bina ve Deprem Yönetmeliği, Resmi Gazete, 18 Mart 2018, 30364.";
          document.querySelector("#notice").style.visibility = "visible";
        }
      }

      if (setting === "tectonic") {
        if (!this.geojsonTectonicPlates) {
          const tectonicPlates = await import("@/assets/data/tectonic.json"); // credits: github/fraxen
          // TECTONIC PLATES
          this.geojsonTectonicPlates = new leaflet.GeoJSON(tectonicPlates);
          this.geojsonTectonicPlates.setStyle({
            color: this.adaptiveColor("rgb(220, 20, 60)"),
            weight: 4,
            fillOpacity: 0,
            opacity: 0.2,
          });
        }
        this.llLayerGroup.hasLayer(this.geojsonTectonicPlates)
          ? this.llLayerGroup.removeLayer(this.geojsonTectonicPlates)
          : this.llLayerGroup.addLayer(this.geojsonTectonicPlates);

        this.layers.TECTONIC = !this.layers.TECTONIC;
      }

      if (setting === "volcanoes") {
        if (!this.volcanoesPlates) {
          const volcanoIcon = leaflet.icon({
            iconUrl:
              "data:image/svg+xml;charset=utf-8," +
              encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64"><path fill="${this.adaptiveColor(
                "#000"
              )}" d="M60.143 60.301c-.104-.095-9.315-8.63-16.702-23.418c1.429.676.15-1.14.15-1.14c-.994-1.225-2.092-5.66-2.771-6.688l-.019-.023c1.413-1.34 3.512-1.861 2.79-3.848c-1.266-3.476-7.305 5.472-4.478.284c2.831-5.191-.129-5.801-.945-4.668c-.532.739-1.596 5.74-2.41 7.295a5 5 0 0 0-.701.116c-.113-.322-.205-.881-.271-1.752c-.5-6.649 7.283-27.021 3.075-24.191c-4.211 2.829-3.656 21.36-6.125 24.473c-2.466 3.112 2.515-20.378.624-22.774c-1.409-1.79-4.942-1.416-3.408 13.719c1.534 15.139-1.02 7.075-2.378 3.255c-1.359-3.817-2.769-2.411-1.335 4.527c1.146 5.559-1.521-2.264-4.636-8.063c-3.113-5.801-10.148-2.546-4.2 1.698c5.513 3.932 6.295 7.379 7.361 10.222c-1.077.957-2.009 3.126-3.035 6.418c-.295.947-.041.865.43.372C14.031 51.498 4.097 60.189 3.99 60.281L2 62h60zm-52.985-.268c3.58-3.579 11.644-12.632 17.316-26.465l.041-.1l.03-.076c.21.236.421.543.647.799c-.973.848-1.613 1.974-1.79 3.387c-.229 1.778-.098 3.281-1.322 4.645c-1.729 1.923-4.219 3.969-3.721 7.098c.686-1.647 1.719-2.909 2.997-4.025c.762-.666 1.593-1.254 2.279-2.019c1.175-1.308 1.445-2.985 1.245-4.771c-.177-1.575-.014-2.76.499-4.123c.44.408.949.513 1.621-.53c1.31-2.028 2.425-1.569 4.224.317c-2.062 1.973-1.462 5.563.232 7.613c1.248 1.508 3.741 3.573 2.91 5.935c2.186-1.518.209-5.072-.978-6.529c-1.645-1.986-2.549-4.151-1.935-6.774c.399.431.83.92 1.305 1.469c.519.6.999 1.057 1.446 1.395c.34 1.623 1.465 3.228 2.43 4.188q-.014-.011-.027-.025c2.39 2.523 1.043 6.429.071 9.391c2.449-2.146 4.367-7.046 1.874-9.972c-.45-.576-1.032-1.005-1.542-1.508a8.4 8.4 0 0 1-1.108-1.3c1.055.127 1.861-.51 2.512-1.365q.22-.29.416-.522a47 47 0 0 1 3.104 8.77c.322 1.307.533 2.659.929 3.941c.483 1.497 1.742 3.687 3.439 3.418c-1.499-.736-1.864-2.968-2.015-4.583a26.5 26.5 0 0 0-.771-4.032c-.786-2.804-2.158-5.863-4.125-8.037c.32-.229.657-.329 1.092-.253c5.854 12.574 13.281 21.188 16.569 24.646H7.158z"/><path fill="currentColor" d="M13.581 55.398c-1.39.946-3.507 2.406-3.733 4.391c1.479-1.131 3.241-1.809 4.782-2.837c1.475-.95 3.129-3.043 2.99-5.085c-1.187 1.284-2.566 2.653-4.039 3.531m14.864-16.26c-.218-1.305-.098-2.573.094-3.869c-1.909 2.089-1.781 5.106-.927 7.7c.833 2.526.334 5.263.092 7.861c1.677-2.029 2.625-5.399 1.794-8.066c-.378-1.21-.844-2.356-1.053-3.626m-3.607 6.22c-.619 2.696-2.181 4.456-3.858 6.388c-1.982 2.28-1.395 5.836.987 7.478c-.44-1.106-.848-2.378-.755-3.608c.049-1.345.798-2.275 1.647-3.13c1.637-1.645 3.034-4.698 1.979-7.128m7.4 2.36c-2.345 1.331-2.079 4.778-.777 6.813c.848 1.332 2.287 2.962 2.258 4.692c1.248-1.281.27-3.904-.428-5.203c-1.139-2.012-1.747-3.939-1.053-6.302m-5.83 3.112c-2.235.826-1.268 4.109-.205 5.523c.5.661 2.451 2.364 2.108 3.436c1.469-.505.085-3.472-.382-4.17c-.917-1.39-2.058-2.951-1.521-4.789m8.424 1.037c.728 1.253 1.571 2.433 2.342 3.656c.815 1.297 1.232 2.773 1.656 4.266c2.384-3.049-.941-7.724-3.998-7.922m9.568 3.75c-1.827-1.395-2.93-3.38-3.739-5.637c-1.285 2.734.655 6.021 2.891 7.167c.334.374 3.314 1.144 2.753 2.076c1.154-.217-.199-2.063-.513-2.404c-.424-.461-.906-.831-1.392-1.202m4.872.768c.645 2.252 3.213 3.356 5.177 2.839c-1.511-.906-3.281-1.953-3.529-4.026l.001.032c-.227-2.116-2.052-3.947-3.878-4.399c.667 1.118 1.419 2.229 1.833 3.5c.219.667.203 1.378.396 2.054m-9.053-37.681c1.714-1.825 2.536-7.484 1.254-5.597c-1.285 1.885-2.33 6.742-1.254 5.597m4.51 5.091c1.654-.503 4.926-6.916 3.349-5.345c-1.578 1.573-5.448 5.983-3.349 5.345m2.426-14.084c-1.783.943-4.88 8.485-5.057 11.319c-.189 3.023 6.839-12.261 5.057-11.319m-23.1 6.641c3.223 2.239-3.358-9.783-3.838-7.396c-.481 2.39 2.414 6.407 3.838 7.396"/></svg>
    `),
            iconSize: [22, 22],
            iconAnchor: [11, 11],
            popupAnchor: [0, -40],
          });

          try {
            const { default: data } = await import(
              "@/assets/data/volcanoes.json"
            );

            this.volcanoesPlates = leaflet.layerGroup(
              data.map((volcano) =>
                leaflet.marker([volcano.latitude, volcano.longitude], {
                  icon: volcanoIcon,
                }).bindPopup(`
          <b>${volcano.vName}</b><br>
          Ülke: ${volcano.country}<br>
          Yükselti: ${volcano.elevation_m}m<br>
          <a href="${volcano.webpage}" target="_blank">Detaylar</a>
        `)
              )
            );
          } catch (error) {
            console.error("Error loading volcano data:", error);
          }
        }

        if (this.llLayerGroup.hasLayer(this.volcanoesPlates)) {
          this.llLayerGroup.removeLayer(this.volcanoesPlates);
        } else {
          this.llLayerGroup.addLayer(this.volcanoesPlates);
        }

        this.layers.VOLCANOES = !this.layers.VOLCANOES;
      }

      this.llmap.setView([coords.lat + 0.01, coords.lng + 0.01]);
    },
    measureChange(event) {
      let setting = event.target.id.split("_")[1];

      if (setting === "clear") {
        document.querySelector(".polyline-measure-clearControl").click();
      }

      if (setting === "drop") {
        this.editorMenu("measure");
        this.measurePanel = false;
      }
    },
    adaptiveColor(color) {
      if (this.isDark) {
        let r, g, b;

        if (color.startsWith("#")) {
          color = color.replace(/^#/, "");
          if (color.length === 3) {
            color = color
              .split("")
              .map((char) => char + char)
              .join("");
          }
          r = parseInt(color.substring(0, 2), 16);
          g = parseInt(color.substring(2, 4), 16);
          b = parseInt(color.substring(4, 6), 16);
        } else if (color.startsWith("rgb")) {
          [r, g, b] = color.match(/\d+/g).map(Number);
        } else {
          return color;
        }

        r = 255 - r;
        g = 255 - g;
        b = 255 - b;

        return `rgb(${r}, ${g}, ${b})`;
      }

      return color;
    },

    filterDateSelection($event) {
      this.filtered = false;
      const selectionBox = $event.target;
      const selectedOption = selectionBox.options[selectionBox.selectedIndex];
      const INPUT = selectedOption.getAttribute("data-date");

      this.applyDateSelection(INPUT);

      this.$nextTick(async function () {
        if (INPUT !== "Son 7 Gün") this.filtered = true;
      });
    },
    async emitFly(lat, lon, quakeId, lastChosenQuake) {
      if (lastChosenQuake !== "customZoom") {
        this.llmap.setView([lat, lon], 8, { animate: false });
      }

      if (lastChosenQuake === quakeId) {
        this.llmap.eachLayer(function (layer) {
          if (layer instanceof leaflet.CircleMarker) {
            layer.setStyle({ opacity: 1, fillOpacity: 1, interactive: true });
          }
        });

        this.llmap.setView([38.5, 40], 6);
        this.llmap.closePopup();
      } else {
        this.llmap.eachLayer(function (layer) {
          if (layer instanceof leaflet.CircleMarker) {
            if (layer.options.dataAttribute === quakeId) {
              layer.setStyle({ opacity: 1, fillOpacity: 1, interactive: true });
              layer.openPopup();
            } else {
              layer.closePopup();
              layer.setStyle({
                opacity: 0,
                fillOpacity: 0,
                interactive: false,
              });
            }
          }
          lastChosenQuake = null;
        });
      }
    },
    async emitFilterMap(displaying) {
      await this.llmap.eachLayer(function (layer) {
        if (layer instanceof leaflet.CircleMarker) {
          if (displaying.includes(layer.options.dataAttribute)) {
            layer.setStyle({ opacity: 1, fillOpacity: 1, interactive: true });
          } else {
            layer.closePopup();
            layer.setStyle({ opacity: 0, fillOpacity: 0, interactive: false });
          }
        }
      });
    },
    getCurrentTime() {
      const options = { year: "numeric", month: "short", day: "numeric" }; // weekday: 'long', hour: 'numeric', minute: 'numeric', second: 'numeric'
      const today = new Date();
      return today.toLocaleDateString("tr-TR", options).replaceAll(":", ".");
    },
    async loadDateSelectionBox() {
      if (this.filterDateLoaded) return;

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;

      for (let year = currentYear; year >= 1904; year--) {
        for (let month = 12; month >= 1; month--) {
          if (year === currentYear && month > currentMonth) {
            continue;
          }
          if (year === 1904 && ![4].includes(month)) {
            continue;
          }

          const monthString = month.toString().padStart(2, "0");
          const monthName = monthNames[monthString];
          const formattedDate = `${year} ${monthName}`;
          const dateValue = `${year}${monthString}`;
          this.filterDateRange.push({ label: formattedDate, value: dateValue });
        }
      }

      this.filterDateLoaded = true;
    },
    displayTooltip(event) {
      const target = event.target;

      if (!target?.dataset?.tip) {
        return;
      }

      let tooltip = document.querySelector("#display-tooltip");

      tooltip.textContent = target.dataset.tip;
      tooltip.style.opacity = 1;

      const rect = target.getBoundingClientRect();

      if (target.dataset?.anchor === "right") {
        tooltip.style.left = `${rect.right - tooltip.offsetWidth}px`;
      } else {
        tooltip.style.left = `${rect.left}px`;
      }

      tooltip.style.top = `${rect.bottom + window.scrollY}px`;
    },
    hideTooltip() {
      let tooltipText = document.querySelector("#display-tooltip");
      tooltipText.style.opacity = 0;
    },
  },
  // created() {

  // },

  async mounted() {
    this.pID = params?.get("id");

    if (params.get("mn") !== null) {
      this.minimumMl = Number(params.get("mn"));
    }

    if (params.get("lat") !== null) {
      this.pLoc.lat = params.get("lat");
      this.pLoc.lon = params.get("lon");
    }

    await this.init();
    window.addEventListener("resize", this.windowResize);

    await this.windowResize();

    const measureElement = document.getElementById("polyline-measure-control");
    measureElement.style.display = "none";
    measureElement.parentElement.style.position = "absolute";
    measureElement.parentElement.style.left = "110px";
    measureElement.parentElement.style.top = "27px";
    measureElement.parentElement.style.bottom = "unset";
    measureElement.parentElement.style.border = "1px solid black";
    measureElement.parentElement.style.borderRadius = ".2rem";
    measureElement.parentElement.classList.add("inactive");
  },
  unmounted() {
    window.removeEventListener("resize", this.windowResize);
  },
  computed: {
    lastUpdate() {
      return this.getCurrentTime();
    },
  },
};
</script>

<style lang="scss" scoped>
#showPortalButton {
  z-index: 99999 !important;
}

#display-tooltip {
  position: absolute;
  width: min-content;
  border-radius: 0.5rem;
  z-index: 10 !important;
  padding: 0.5rem;
  margin: 0.5rem;
  margin-left: 0;
  background-color: rgba($color: #000000, $alpha: 0.6);
  color: #fff;
  opacity: 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: small;
  font-weight: 100;
}

.paramCoordMarker {
  stroke-dasharray: 50 !important;
  animation: dash 5s linear infinite !important;
  transform-origin: center !important;
}

@keyframes dash {
  to {
    stroke-dashoffset: 20;
    transform: rotate(360deg);
  }
}
.custom-popup .leaflet-popup-content-wrapper {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  z-index: 9999;
}

#showHUDButton {
  position: relative;
}
#hudPanel {
  position: absolute;
  max-height: 20px;
  width: max-content;
  left: 105px;
  top: 0;
}

#topbar {
  position: absolute;
  z-index: 5;
  width: 100vw;
  height: 32px;
  padding: 10px;
  transition: 200ms ease-in-out;
  pointer-events: none;

  button {
    float: left;
    display: flex;
    align-items: center;
    border: 1px solid gray;
    pointer-events: auto;
  }

  i {
    font-size: 20px;
  }

  div {
    gap: 5px;
  }

  @media (min-width: 2048px) {
    height: 64px;

    button {
      height: 60px;
    }

    i {
      font-size: 45px;
    }

    div {
      gap: 10px;
    }
  }

  @media (min-width: 3700px) {
    padding: 15px 30px;
    height: 78px;

    button {
      height: 40px;
    }

    i {
      font-size: 34px;
    }

    div {
      gap: 10px;
    }
  }

  #filterDateSelectionBox {
    // margin: 0;

    pointer-events: auto;
    // font-size: clamp(1rem, 1vw, 2rem);
    // border: 1px solid rgba($color: #b2cee6, $alpha: 0.4);
    // border-radius: 2vw;
    // padding: 0;
    margin-left: 0.2rem;

    border: 1px solid gray;
    background: rgba($color: #fff, $alpha: 0.4);
    padding: 0;
    padding: 0 10px 0 10px;
    border-radius: 0.5rem;
    text-decoration: none;

    height: 34px;
    font-size: 16px;

    @media (min-width: 2048px) {
      height: 56px;
      font-size: 24px;
    }

    @media (min-width: 3700px) {
      height: 40px;
      font-size: 26px;
    }

    &:hover {
      background: rgba($color: #fff, $alpha: 0.6);
      cursor: pointer;
    }
  }
  .hideOnMobile {
    @media only screen and (max-width: 600px) {
      display: none;
    }
  }
}

.topbar_extend {
  display: flex;
  flex-direction: column;
  background-color: rgba($color: white, $alpha: 1);
  padding: 0.5rem;
  border-radius: 0.5rem;
  width: max-content;
  margin-top: 0.5rem;
  color: black;
  z-index: 2;

  span,
  i,
  button {
    font-size: clamp(1rem, 1vw, 1.5rem);
  }
}

.side_buttons {
  .side_legend,
  .darklight_mode {
    background-color: white;
    border-radius: 0;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 4px 10px;
    width: min-content;

    font-size: clamp(1rem, 1.3vw, 5rem);

    z-index: 1;
    transition: all 220ms linear;
    &:hover {
      cursor: pointer;
      box-shadow: (0 0 2px black);
    }

    p {
      font-size: small !important;
      margin: 0 !important;
      padding: 0;
    }

    @media only screen and (max-width: 600px) {
      display: none;
    }
  }

  .la-times-circle {
    position: absolute;
    top: 0;
    right: 0;
    font-size: small !important;
  }

  position: absolute;
  text-align: center;
  display: flex;
  gap: 4px;
  flex-direction: column;
  left: 0px;
  bottom: 3rem;
}

.depth_info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: flex-start;

  gap: 4px;
}

.magnitude_info {
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  &::before {
    content: " 1     2      3      4";
    white-space: pre;
    position: absolute;
    bottom: -0.5rem;
    left: -4px;

    font-size: small;
  }

  // &::before {
  //   content: "0+";
  //   position: absolute;
  //   bottom: -1rem;
  //   left: 0px;

  //   font-size: small;
  // }

  // &::after {
  //   content: "5+";
  //   position: absolute;
  //   bottom: -1rem;
  //   right: 3px;

  //   font-size: small;
  // }
}

//   padding: .2vw;
//   margin-bottom: 5px;

//   display: flex;
//   align-items: center;

//   border-radius: .5vw;

//   background-color: white;

//   .las {
//     font-size: 1vw;
//   }

//   .plateItem {
//     margin: 0 1vw;
//     .plateItemTooltip {
//       visibility: hidden;

//       background-color: white;
//       border-radius: 5px;
//       padding: 7px;
//       border: 1px solid black;

//       min-width: 7rem;
//       margin-bottom: 5px;

//       position: absolute;
//       bottom: 0px;
//       left: calc(100% + 5px);
//       z-index: 1;
//     }

//     &:hover {
//       opacity: 1;
//       .plateItemTooltip {
//         visibility: visible;
//       }
//       * {
//         cursor: pointer;
//       }
//     }
//   }

//   button {
//     display: flex;
//     align-items: center;
//     width: fit-content;
//     height: 40px;
//     font-size: 1vw;
//     i {
//       margin-right: .4vw;
//     }
//     margin: 0 .2          vw;

//     &:hover {
//       .plateItemTooltip {
//         visibility: visible;
//       }
//       * {
//         cursor: pointer;
//       }
//     }
//   }
// }

.timeBox {
  color: black;
  margin-left: 10px;
  z-index: 2;
}

#editorMenu {
  @media only screen and (max-width: 600px) {
    display: none;
  }
}

#graphContainer {
  padding: 0.2rem;
  position: absolute;
  top: 50%;
  left: 50%;
  height: min-content;
  min-width: 620px;
  width: max-content;
  transform: translate(-50%, -50%);
  z-index: 99999;
  background: white;
  border-radius: 20px;
  box-shadow: 0 0 5px black;

  #graphCloseButton {
    padding: 2px 8px;
    background-color: white;
    filter: drop-shadow(0 0 2px black);
    border-radius: 9999px;
    font-size: 1rem;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
.containerMap {
  position: relative;
  #map {
    height: 85%;
    width: 70%;
    position: fixed;
    transform: translate(5%, 5%);
  }
  #llmap {
    height: 100%;
    // @media only screen and (max-width: 600px) {
    //   height: calc(100% - 4rem);
    // }
  }
  z-index: 0;
}
.labels {
  font-size: large;
  color: black;
  position: absolute;
  z-index: 3;
  &:hover {
    cursor: pointer;
    filter: brightness(2);
  }
}
/*--====== Sidebar ======--*/
#sidebar {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 2;
  padding-bottom: 0.2rem;
  // width: fit-content;
  height: 100%;

  max-width: 25rem;
  min-width: 25rem;

  @media only screen and (min-width: 2048px) {
    max-width: 40rem;
    min-width: 40rem;
  }

  @media only screen and (min-width: 3700px) {
    max-width: 50rem;
    min-width: 50rem;
  }

  overflow-x: hidden;
  overflow-y: auto;
  opacity: 0;
  transform: translateX(50%);
  visibility: hidden;
  transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out,
    transform 200ms ease-in-out;

  @media only screen and (max-width: 600px) {
    padding-bottom: 1rem;
    max-width: unset;
    min-width: unset;
    width: 100%;
    transform: translateX(0%);
  }
}
/* when the sidebar has 'show' class */
#sidebar.show {
  pointer-events: all;
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}
// .sidebar_content {
//   padding: 1rem 0;
// }

#sidebar.show + .sidebar_toggler {
  justify-content: center;
}
#sidebar.show + .sidebar_toggler span {
  margin-top: -1.2px;
  margin-bottom: -1.2px;
}

.info-section {
  position: absolute;
  top: 2rem;
  left: 2rem;
  font-size: 1rem;
}
</style>
